import dpharmaImage from './dpharma.png';
export const Bio = {
  name: "Vikas Joshi",
  roles: [
    "I am a Full Stack Software and Blockchain Developer,",
    "UI/UX Designer and",
    "Programmer",
  ],
  description:
    "I am a motivated and adaptable individual, always ready to embrace new challenges. With a passion for learning, I am committed to delivering top-quality results. My positive attitude and growth mindset equip me to make significant contributions and accomplish remarkable achievements.",
  github: "https://github.com/vicky262600",
  resume:
    "https://drive.google.com/file/d/1M2dtUtBkG5otq-CrE-zJ0w8-_ozWBgP1/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/vikas2604/",
  twitter: "https://x.com/VikasJoshi26824",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      }
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Django",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlFFyY16N5NRhzoG24RqB7x8Ok2t8Bdgs-tuMsOBXS2Q&s",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmTY5cYv",
    role: "JavaScript Developer",
    company: "EHR LOGIC",
    date: "January 2024 – Present",
    desc: "Worked as a JavaScript Developer at EHR LOGIC, contributing to the development and maintenance of scalable web applications. Collaborated closely with cross-functional teams to design, implement, and optimize features using clean and efficient JavaScript code. Focused on improving application performance, fixing bugs, and ensuring reliable, high-quality software delivery in a remote work environment.",
    skills: [
      "NextJS",
      "ReactJS",
      "Redux",
      "Express",
      "NodeJs",
      "MongoDB",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  {
    id: 1,
    img: "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmTY5cC2wSv13CYEJc9K7RP6xmXizKWPxhS1XzCirNhKYv",
    role: "Junior Software Developer",
    company: "Kash Info Solutions Pvt. Ltd. Surat, Gujarat",
    date: "May 2022 - January 2024",
    desc: "Leveraging expertise in the MERN stack, I have successfully developed and deployed high-performing web applications with load times under 2 seconds. My work includes engineering secure and scalable RESTful APIs using Node.js and Express.js, optimizing MongoDB queries to enhance integration efficiency by 25%. By utilizing Docker for containerization, I streamlined deployment pipelines, ensuring consistency across environments. Collaborating in agile teams, I actively contributed to sprint planning, code reviews, and peer mentoring while maintaining a 95% defect-free production code rate. Through advanced caching strategies and optimized database indexing, I improved application performance, supported by detailed technical documentation for seamless knowledge sharing and onboarding.",
    skills: [
      "ReactJS",
      "Redux",
      "Express",
      "NodeJs",
      "MongoDB",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  {
    id: 2,
    img: "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/Qmc4kycNTbAveUsTwt22zS8fYSA1YLF27g3v4z7tGCzjgz",
    role: "Software Developer",
    company: "Core Medical Instruments Pvt. Ltd.",
    date: "January 2022 – April 2022",
    desc: "I spearheaded the design and implementation of an intuitive front-end architecture using Vue.js, HTML, and CSS, enhancing user experience and boosting engagement by 30%. By seamlessly integrating APIs with Django, I ensured efficient data management and demonstrated full-stack development expertise. Optimizing the application for scalability and responsiveness improved its performance and maintained reliability for over 5,000 monthly users. Through extensive testing and debugging, I guaranteed cross-browser compatibility and minimized downtime. Collaborating with a multidisciplinary team, I successfully delivered the project on schedule while meeting client expectations.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "VueJs",
      "Django",
      "Figma",
      "Axios",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },  
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "May 2023 - Present",
    desc: "Contributed to different open-source projects and learn from industry experts",
  },
];

export const education = [
  {
    id: 0,
    img: "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmNkGcZwMFQMYnBFuh5TiTu6TVow1NWNNirZGbwWzXFMS7",
    school: "Lambton College, Sarnia",
    date: "Sep 2023 - May 2025",
    grade: "3.6 GPA",
    desc: "I am currently pursuing a PG Program in Full Stack Software Development at Lambton Collage, Sarnia.",
    degree: "PG of Full Stack Software Development",
  },
  {
    id: 1,
    img: "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmTf6DC3dT4NGHig7j67RkBxhVxcspXZgxurYCcKyFfPSQ",
    school: "Dr jivraj mehta institute of technology (GTU University)",
    date: "Sep 2018 - May 2022",
    grade: "8.21 CGPA",
    degree: "Bachelor of Technology - BE, Computer Science Engineering",
  },
  {
    id: 1,
    img: "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmQgFdVgwJxf2WtyfecMZo9EHpK6jhNdckHD6kqap7jeEB",
    school: "Adarsh Vidhya Mandir, Beawar",
    date: "Apr 2017 - Apr 2018",
    grade: "71.4%",
    degree: "RBSC(XII)",
  },
  {
    id: 2,
    img: "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmQgFdVgwJxf2WtyfecMZo9EHpK6jhNdckHD6kqap7jeEB",
    school: "Adarsh Vidhya Mandir, Beawar",
    date: "Apr 2015 - Apr 2016",
    grade: "78.0%",
    degree: "RBSC(X)",
  },
];

export const projects = [
  {
    id: 11,
    title: "Popular Movies IMDB",
    description:
      "I utilized my Python and data analysis skills to thoroughly examine movie datasets. Leveraging NumPy and Pandas, I efficiently processed and manipulated the data to extract meaningful insights. To visually represent the findings, I employed Matplotlib and Seaborn, creating clear and informative visualizations that highlighted key trends and patterns within the movie industry.",
    image:
      "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmNnvDG1L7UjRqB45VsC3eyaJikxovTQYczYRdg41Y43gt",
    tags: [
      "Python",
      "NumPy",
      "Pandas",
      "Matplotlib",
      "Seaborn",
    ],
    category: "data analysis",
    webapp: "https://jovian.com/vikasjoshi2604/popular-movies-imdb00cp",
  },
  {
    id: 9,
    title: "WhatsApp Web Clone",
    description:
      "I developed a real-time chat application using React JS for the frontend and Firebase for the backend. Gmail account holders can create chat rooms and engage in conversations, with Firebase ensuring instant message updates and a smooth user experience.",
    image:
      "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmQD7Ptp4XJBPEC7VZmtfrXzHdyogXuY7rAMzCZZD5Y2aH",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Firebase Authentication",
      "React Js",
      "Firebase",
    ],
    category: "web app",
    github: "https://github.com/vicky262600/WhatsApp-Clone",
    webapp: "https://whats-app-clone-lac.vercel.app/",
  },
  {
    id: 0,
    title: "RIRA Social Media",
    description:
      "I created a social media site using React JS, Express, Node.js, Firebase, and MongoDB. Users can register, log in with their credentials, and are then redirected to a homepage where they can view, like, and post images with descriptions.",
    image:
      "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmdFncSvyjfGHP23ahUmrxyx6eR9XnDgrUhTiSKjGJZvpE",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux", "Firebase", "Postman"],
    category: "web app",
    github: "https://github.com/vicky262600/redux-FE",
    githubBE: "https://github.com/vicky262600/redux-server",
    webapp: "https://redux-fe.vercel.app/",
  },
  {
    id: 1,
    title: "RIRA E-commerce",
    description:
      "I'm excited to announce the completion of my e-commerce project using React, Express, MongoDB, Node.js, Stripe for payment, JWT, Redux, and Persist. This project features user registration, product browsing, cart management, and secure payments, enhancing my full-stack development skills and user experience design.",
    image:
      "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmbYdKeEckojk9whryWytr5TVCqyhcyonGnBe5dWGVjiRh",
    tags: [
      "React Js",
      "Stripe",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "Postman",
    ],
    category: "web app",
    github: "https://github.com/vicky262600/RIRA-Ecommerce-FE",
    githubBE: "https://github.com/vicky262600/RIRA-Ecommerce-API",
    webapp: "https://rira-ecommerce-fe.vercel.app/",
  },
  {
    id: 15,
    title: "Blog Platform",
    description:
      "Developed a full-stack blog platform using Next.js, MongoDB, and Firebase, allowing users to register/login via Google authentication or custom credentials with NextAuth. Users can create, update, and delete blog posts with images stored in Firebase and URLs saved in MongoDB. Implemented secure authentication, efficient data fetching with SWR, and a seamless user experience.",
    image:
      "https://private-user-images.githubusercontent.com/145147066/412031208-db2dd9c8-867c-44b4-b5e0-d64d902f39f8.png?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3MzkyODY3NDEsIm5iZiI6MTczOTI4NjQ0MSwicGF0aCI6Ii8xNDUxNDcwNjYvNDEyMDMxMjA4LWRiMmRkOWM4LTg2N2MtNDRiNC1iNWUwLWQ2NGQ5MDJmMzlmOC5wbmc_WC1BbXotQWxnb3JpdGhtPUFXUzQtSE1BQy1TSEEyNTYmWC1BbXotQ3JlZGVudGlhbD1BS0lBVkNPRFlMU0E1M1BRSzRaQSUyRjIwMjUwMjExJTJGdXMtZWFzdC0xJTJGczMlMkZhd3M0X3JlcXVlc3QmWC1BbXotRGF0ZT0yMDI1MDIxMVQxNTA3MjFaJlgtQW16LUV4cGlyZXM9MzAwJlgtQW16LVNpZ25hdHVyZT1lNjNhNDExZDc5MDBiMDVhZjg2N2Y5M2M0NjNkNDFhMjVkZDVlNjRmMzRjMDA0YWYwNDJjZjUzMmE2MGM0ODZkJlgtQW16LVNpZ25lZEhlYWRlcnM9aG9zdCJ9.35Jw7c2f5SeqEAQ2BObnToPhw_FWD6BKG-aZUoVGnvg",
    tags: [
      "Next.js",
      "MongoDb",
      "Node Js",
      "NextAuth",
      "Firebase",
    ],
    category: "web app",
    github: "https://github.com/vicky262600/first-nextJs-project",
    webapp: "https://rira-blogs.vercel.app/",
  },
  {
    id: 3,
    title: "RIRA D-Voting",
    description:
      "I developed a secure Ethereum voting app with MetaMask integration, enabling real-time voting and smart contract interactions using ethers.js. Through this project, I advanced my skills in blockchain development, Solidity, and Web3 integration, applying them in a fully functional DApp on the Base Sepolia Testnet.",
    image:
      "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmTveVwxjuxfBbrsexnXAqhsF2ojCyhc7dAw1vz6A5eaGk",
    tags: [
      "Solidity",
      "Ethers.js",
      "Hardhat",
      "Node Js",
      "Base Sepolia Testnet",
    ],
    category: "Decentralized app",
    github: "https://github.com/vicky262600/voting-FE-react",
    githubBE: "https://github.com/vicky262600/voting-hardhat",
    webapp: "https://voting-fe-react.vercel.app/",
  },
  {
    id: 11,
    title: "RIRA D-pharma",
    description:
      "I developed a decentralized prescription management system using React, Hardhat, Privy, and deployed it on the Base Sepolia Testnet. This project enhances healthcare transparency and efficiency by enabling secure, tamper-proof interactions between doctors, patients, and pharmacies. It features a user-friendly interface and robust privacy measures, ensuring seamless and trustworthy prescription management through blockchain technology.",
    image: dpharmaImage,
    tags: [
      "Solidity",
      "Privy",
      "Ethers.js",
      "Hardhat",
      "Node Js",
      "Base Sepolia Testnet",
    ],
    category: "Decentralized app",
    github: "https://github.com/vicky262600/d-pharma-flow-fe",
    githubBE: "https://github.com/vicky262600/d-pharma-hardhat",
    webapp: "https://d-pharma.vercel.app/",
  },
  {
    id: 17,
    title: "Embrosoul – Full-Stack E-commerce Platform",
    description:
      "Designed, developed, and deployed a production-ready e-commerce platform used by real customers. Built an SEO-friendly, server-rendered frontend with Next.js and implemented secure REST APIs using Node.js and Express. Integrated JWT-based authentication, Stripe payments, Firebase Storage for image uploads, and deployed the application on Vercel with a custom domain via GoDaddy. This project provided hands-on experience with real payment flows, production deployments, performance optimization, and SEO best practices.",
    image: "",
    tags: [
      "Next.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "JWT",
      "Stripe",
      "Firebase Storage",
      "Vercel",
      "GoDaddy"
    ],
    category: "web app",
    github: "https://github.com/vicky262600/Nirvana",
    webapp: "https://www.embrosoul.com",
  },
  
  {
    id: 4,
    title: "CLI Real-time Cryptocurrency Prices",
    description:
      "A Node.js CLI tool that displays real-time cryptocurrency prices! By using Commander to handle commands, Inquirer for interactive prompts, and Axios to fetch data from the CoinMarketCap API, this tool provides up-to-date information for anyone interested in tracking crypto trends.",
    image:
      "https://peach-advisory-zebra-318.mypinata.cloud/ipfs/QmRgoTQQKbtskn9wPMpnWAiaKmPpysAZDi8USZy671GmUa",
    tags: [
      "Node.js",
      "Commander",
      "Inquirer",
      "Axios",
      "CoinMarketCap API"
    ],
    category: "CLI",
    github: "https://github.com/vicky262600/CLI-Cryptocurrency-Prices",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
